import styled from 'styled-components';

const CopyClipBoardButtonStyled = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background-color: var(--Brown-40);

  & img {
    vertical-align: middle;
  }
`;

export default CopyClipBoardButtonStyled;
